export class GetParamsRequest {
    constructor(deviceGuid) {
        this.DeviceGuid = "";
        this.DeviceGuid = deviceGuid;
    }
}
export class GetChannelParamsRequest {
    constructor(deviceGuid, channel) {
        this.DeviceGuid = "";
        this.Channel = 0;
        this.DeviceGuid = deviceGuid;
        this.Channel = channel;
    }
}
//# sourceMappingURL=DataRequest.js.map